import { autoCapitalize } from '@conexasaude/front-utils/formatters'
import {
  GetProfessionalByPatient,
  GetProfessionalByPatientResponse,
} from '../../../TelemedicineServices.types'

class MedicalRecordReportMapper {
  toPersistence(data: GetProfessionalByPatient) {
    return {
      termo: data.term,
      idPaciente: data.patientId,
    }
  }

  toDomain(data: GetProfessionalByPatientResponse[]) {
    return data.map(item => ({
      id: item.id,
      fullName: autoCapitalize(item.fullName),
    }))
  }
}

export default new MedicalRecordReportMapper()
